import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M8.929 9.429c-3.905 3.905-3.905 10.237 0 14.142 3.905 3.905 10.237 3.905 14.142 0 3.905-3.905 3.905-10.237 0-14.142C21.107 7.465 18.381 6.5 16 6.5h-3.81M15 3l-3.5 3.5L15 10"
      fill="none"
    />
  </Icon>
);
